<div class="flex flex-col items-start relative">
  <div class="flex flex-col items-start px-8">
    <span [class]="'text-left text-mbaza-primary text-lg lg:text-2xl mb-2 font-bold'">
      {{ number }}
    </span>
    <span class="text-mbaza-gray text-xs">{{ name }}</span>
  </div>
  <div
    *ngIf="!last"
    class="absolute right-0 top-1/4 h-1/2 w-[1px] bg-mbaza-gray-dark"
  ></div>
</div>
